module.exports = __webpack_public_path__ + "static/assets/9ed9286dcb50a1ab3ee4c1492a0ac801.svg";